import React from 'react';

const Wrapper = ({ children, customClass }) => {
  return (
    <div className={`p-3 bg-[--light-gray] overflow-auto !min-h-[calc(100vh-57px)] ${customClass}`}>
      {children}
    </div>
  );
}

export default Wrapper;
